import { fontWeights } from "./fonts";

let typography = {
  h1: {
    fontSize: "2.5rem",
    fontWeight: fontWeights.extraBold,
    lineHeight: "3rem",
    letterSpacing: "normal"
  },
  h2: {
    fontSize: "1.8975rem",
    fontWeight: fontWeights.bold,
    lineHeight: "2.25rem",
    letterSpacing: "normal"
  },
  h3: {
    fontSize: "1.518rem",
    fontWeight: fontWeights.semiBold,
    lineHeight: "1.625rem",
    letterSpacing: "normal"
  },
  h4: {
    fontSize: "1.265rem",
    fontWeight: fontWeights.bold,
    lineHeight: "1.5rem",
    letterSpacing: "normal"
  },
  h5: {
    fontSize: "1.1rem",
    letterSpacing: "normal",
    fontWeight: fontWeights.semiBold,
  },
  h6: {
    fontSize: "1rem",
    fontWeight: fontWeights.bold,
    letterSpacing: "normal",
  },
  subtitle1: {
    fontWeight: fontWeights.semiBold,
    letterSpacing: "normal",
    fontSize: "1rem"
  },
  subtitle2: {
    fontWeight: fontWeights.bold,
    fontSize: "0.875rem",
    letterSpacing: "normal",
  },
  body1:{
    fontWeight: fontWeights.regular,
    letterSpacing: "0.5px",
    fontSize: "1rem",
    letterSpacing: "normal",
  },
  body2:{
    fontWeight: fontWeights.regular,
    letterSpacing: "0.25px",
    letterSpacing: "normal",
  },
  button: {
    fontWeight: fontWeights.bold,
    fontSize: "1rem",
    letterSpacing: "normal",
  },
  caption: {
    fontWeight: fontWeights.regular,
    fontSize: "0.75rem",
    letterSpacing: "normal",
  },
  overline: {
    fontWeight: fontWeights.regular,
    fontSize: "0.625rem",
    letterSpacing: "normal",
  },
  fontFamily: [
    "BuckeyeSans",
    "Open Sans",
    "-apple-system",
    "BlinkMacSystemFont",
    '"Segoe UI"',
    "Roboto",
    '"Helvetica Neue"',
    "Arial",
    "sans-serif",
    '"Apple Color Emoji"',
    '"Segoe UI Emoji"',
    '"Segoe UI Symbol"'
  ].join(","),
};

export default typography